const ICONS = {
    'PATH': 'resources/icons/',
    'fr' : 'fr-icon.png',
    'en' : 'eng-icon.png',
    'HOME' : 'home_icon.png',
    'YOUTUBE' : 'youtube.png',
    'INSTA' : 'instagram.png',
    'BLUE_DISCORD' : 'discord_blue.png',
    'DISCORD' : 'discord.png',
    'COFFEE' : 'coffee.png',
    'KOFI_LARGE' : 'kofi-large.png',
    'MENU' : 'menu.png'
}

Object.freeze(ICONS);
export default ICONS;